// extracted by mini-css-extract-plugin
export default {"wrapper":"BatchBindRuleGroup_wrapper__jcA+m","col":"BatchBindRuleGroup_col__Zgj2p"};